import React, { useState } from 'react';
import { InfoIcon, Loader2Icon } from 'lucide-react';
import { UtilityHero } from '../components/utility/UtilityHero';
import { SubscribeForm } from '../components/whatsnew/SubscribeForm';
import { FilterChips } from '../components/whatsnew/FilterChips';
import { ReleaseTimeline } from '../components/whatsnew/ReleaseTimeline';
import { productFilters, releases } from '../data/changelog';
type Filter = (typeof productFilters)[number];
export function WhatsNew() {
  const [filter, setFilter] = useState<Filter>('All');
  const [showOlder, setShowOlder] = useState(false);
  const [loadingOlder, setLoadingOlder] = useState(false);
  const visible = releases.filter(r => (showOlder || !r.older) && (filter === 'All' || (r.products as string[]).includes(filter)));
  const hasOlder = !showOlder && releases.some(r => r.older);
  const loadOlder = () => {
    setLoadingOlder(true);
    window.setTimeout(() => {
      setShowOlder(true);
      setLoadingOlder(false);
    }, 600);
  };
  return <main data-id="element-2250" data-mp="3cgkscw08bngk">
      <section className="hero-surface w-full" aria-labelledby="whats-new-heading" data-id="element-2251" data-mp="3cgb1753g7a9a">
        <div className="mx-auto max-w-shell px-6 pb-14 pt-16 lg:pb-20 lg:pt-24" data-id="element-2252" data-mp="37nro098oah50">
          <UtilityHero titleId="whats-new-heading" title="What’s new in Kayko" subtitle="The latest features and improvements, released for your business." data-id="element-2253" data-mp="32p6okc18w1hm">
            <SubscribeForm data-id="element-2254" data-mp="3vencoxhu0w81" />
          </UtilityHero>
        </div>
      </section>

      <section className="w-full bg-white py-12 lg:py-16" aria-label="Release notes" data-id="element-2255" data-mp="3qfk638m7ehxy">
        <div className="mx-auto max-w-shell px-6" data-id="element-2256" data-mp="3lg7jmoz8vcvw">
          <FilterChips options={productFilters} value={filter} onChange={setFilter} data-id="element-2257" data-mp="3lewf2mxz613q" />

          <p className="mx-auto mt-8 flex max-w-[640px] items-start gap-2.5 rounded-[10px] border border-dashed border-ink/20 px-4 py-3 text-[13px] leading-[1.5] text-ink-muted" data-id="element-2258" data-mp="3hdkoae3d79ty">
            <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-2259" data-mp="25yxpmsw50tst" />
            <span data-id="element-2260" data-mp="27gmknj1zf4mv">
              <span className="font-semibold text-ink" data-id="element-2261" data-mp="27g33i4k5ok9w">Placeholder release notes.</span> The entries below are sample
              content for design review and will be replaced with real updates.
            </span>
          </p>

          <div className="mt-12" data-id="element-2262" data-mp="1xhnb7y9e74yt">
            {visible.length > 0 ? <ReleaseTimeline entries={visible} data-id="element-2263" data-mp="22h04p1urraad" /> : <div className="mx-auto max-w-[480px] rounded-[14px] border border-canvas-line px-6 py-10 text-center" data-id="element-2264" data-mp="22jcjx79576jq">
                <p className="text-[16px] font-semibold text-ink" data-id="element-2265" data-mp="1tglb7f7niovs">No {filter} updates yet</p>
                <p className="mt-2 text-[14px] text-ink-muted" data-id="element-2266" data-mp="1es7770yi0udn">
                  {hasOlder ? 'Try loading older updates, or choose another product.' : 'Choose another product to see its updates.'}
                </p>
                <button type="button" onClick={() => setFilter('All')} className="mt-5 text-[15px] font-semibold text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-2267" data-mp="15r0nkj0jz3g6">
                  Show all updates
                </button>
              </div>}
          </div>

          <div className="mt-10 flex justify-center lg:mt-4 lg:pl-[220px]" data-id="element-2268" data-mp="1058iveuxug35">
            {hasOlder ? <button type="button" onClick={loadOlder} disabled={loadingOlder} aria-busy={loadingOlder} className="inline-flex h-12 items-center gap-2 rounded-[7px] border border-ink/20 bg-white px-6 text-[15px] font-semibold text-ink transition-colors duration-150 ease-out hover:border-ink/45 disabled:cursor-wait" data-id="element-2269" data-mp="v65d1s74w5u4">
                {loadingOlder && <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-2270" data-mp="1etwd9ht1sjri" />}
                {loadingOlder ? 'Loading…' : 'Load older updates'}
              </button> : <p className="text-[14px] text-ink-muted" data-id="element-2271" data-mp="1nvm0scjt6yk0">You’re all caught up.</p>}
          </div>
        </div>
      </section>
    </main>;
}